import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ToastService, ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);

  readonly toasts = this.toastService.toasts;

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  toastClass(type: ToastType): string {
    const accent: Record<ToastType, string> = {
      success: 'border-l-success',
      error: 'border-l-danger',
      warning: 'border-l-warning',
      info: 'border-l-dark-accent',
    };
    return `toast-enter pointer-events-auto w-full sm:w-80 bg-dark-surface border border-dark-border border-l-2 ${accent[type]} rounded-lg px-4 py-3 flex items-start gap-3 shadow-lg`;
  }

  iconClass(type: ToastType): string {
    const color: Record<ToastType, string> = {
      success: 'text-success',
      error: 'text-danger',
      warning: 'text-warning',
      info: 'text-dark-accent',
    };
    return `mt-0.5 shrink-0 ${color[type]}`;
  }
}
